module.exports = __webpack_public_path__ + "static/media/24WingChunAcademyLR-46.0ca1021c.jpg";